// Checklist - PAVADINIMAS (puslapis)

page.checklist.BuyingEko = {
    enabled: false,
    ready: false,
    needsLoad: false,
    progress: 0,
    check: function(){ // Šitą funkciją vykdo kai tikrina užkrauto puslapio DOM, ieško elementų
        this.reset();
        if(page.v.firstLoad) this.first();  // Pirmą kart užkrovus tinklapį galima susikurti kažkokius pastovius kintamuosius ir t.t.

        if($('.barba-container').data('namespace') == 'buying_eko'){ // jei randi reikiamą elementą - modulis įjungiamas.
            log.page("CHECK: BUYING EKO detected", 2);
            this.enabled = true;
        }
    },
    reset: function(){
        this.enabled = false;
        this.ready = false;
        this.needsLoad = false;
        this.progress = 0;
    },
    init: function(){ // Ši funkcija vykdoma iškart po DOM apdorojimo, galima kabint eventus ir t.t.
       // page.transitions('buying', 900);

        let name = $('.barba-container').data('namespace');
        page.transitions(name, 900);
        page.main.fr.altMenu.alt();
        /* page.control.particles.speedTo(0.1, 1000);
        page.control.particles.fadeTo(0.5, 1500);
        page.control.particles.scrolling(true); */
        page.main.v.marketSticky.play(0);
        let hash = window.location.hash;
        if(hash){
            let sectionHeight = $(hash).outerHeight();
            let wHeight = $(window).height();
            let offest = wHeight - sectionHeight;


            $('html, body').animate({
                scrollTop: $(hash).offset().top + 40//- offest
            }, 1300);
        }
       // console.log('wtf');
        this.resize();
    },
    first: function(){ // Ši funkcija vykdoma pirmą kartą užkrovus tinklapį

    },
    unload: function(){ // Ši funkcija skirta išvalyti eventams prieš nukraunant puslapį per ajax.
        //page.control.bg.fadeColor(0,600);
    },
    calc: function(){ // Ši funkcija vykdoma kiekvieno kadro metu (animacijoms ir t.t.)

    },
    resize: function(){ // onResize funkcija (pati administruojasi, nereikia atrišinėti)

    },
    scroll: function(){ // onScroll funkcija (pati administruojasi)

    },
    v: {
        // Jei reikalingi vidiniai kintamieji programos darbui, kurie turi išlikti tarp funkcijų vydymo
    },
    f: {
        // Jei reikalingos papildomos vidinės funkcijos modulio veikimui
    }
}